module.exports = __webpack_public_path__ + "img/GH.21fdc5f4.svg";